export default __webpack_public_path__ + "static/media/STL_June_24.1efcf66b.pdf";